import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ITachographDayData } from '@src/app/interfaces/tachograph.interface';
import { TachographChartComponent } from '../tachograph-chart/tachograph-chart.component';
import { FormatMinutesToHumanizePipe } from '@shared/pipes/format-minutes-to-humanize.pipe';

@Component({
  selector: 'app-tachograph-day-list',
  standalone: true,
  imports: [CommonModule, FormatMinutesToHumanizePipe, TachographChartComponent, TranslateModule],
  providers: [FormatMinutesToHumanizePipe],
  templateUrl: './tachograph-day-list.component.html',
  styleUrls: ['./tachograph-day-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TachographDayListComponent implements OnInit {
  @Input() public tachographData: ITachographDayData;
  public date: Date;

  ngOnInit(): void {
    this.date = new Date(this.tachographData.Date);
  }
}
